// extracted by css-extract-rspack-plugin
export default {"version":"h_zAwuX8XhI5uNF1","separator":"OwTxiZ8HWst61VE6"};